export default "__VITE_ASSET__DDKb7xAS__"